/**
 * Create a thumbnail from video
 * @param {HTMLVideoElement} video
 * @param {Number} thumbnailSize
 * @returns image url (string)
 */
export const getVideoThumbnail = (video, thumbnailSize) => {
  const canvas = document.createElement('canvas')
  canvas.width = thumbnailSize
  canvas.height = thumbnailSize
  const context = canvas.getContext('2d')
  const startCropX = getStartCrop(video.videoWidth, thumbnailSize)
  const startCropY = getStartCrop(video.videoHeight, thumbnailSize)
  const width = getSizeToCrop(thumbnailSize, video.videoWidth, startCropX)
  const height = getSizeToCrop(thumbnailSize, video.videoHeight, startCropY)

  context.drawImage(
    video,
    startCropX,
    startCropY,
    width,
    height,
    0,
    0,
    thumbnailSize,
    thumbnailSize
  )

  return canvas.toDataURL('image/png')
}

/**
 * Get video width or height and return a start point to get image
 * @param {Number} widthOrHeight
 * @param {Number} thumbnailSize
 * @returns Number
 */
export const getStartCrop = (widthOrHeight, thumbnailSize) => {
  return widthOrHeight / 2 - thumbnailSize
}

/**
 * Get thumbnail size, width or height and start point of the crop and return the
 * size (width or height) to crop image.
 * If the initial crop size is bigger than image, return the max size of the image
 * @param {Number} thumbnailSize
 * @param {Number} widthOrHeight
 * @param {Number} startCropXorY
 * @returns Number
 */
export const getSizeToCrop = (thumbnailSize, widthOrHeight, startCropXorY) => {
  const sizeToCrop = thumbnailSize * 3 //Initial crop width or height size
  return sizeToCrop + startCropXorY > widthOrHeight
    ? sizeToCrop - (startCropXorY + sizeToCrop - widthOrHeight)
    : sizeToCrop
}
